
/**
 * 设置初始化动画
 *
 * @param {Object} params 参数对象
 * @param {boolean} params.isFeedAnimation 是否启用动画
 * @param {Object} params.animationParam 动画参数
 * @param {number} params.animationParam.width 动画宽度
 * @param {number} params.animationParam.left 动画左边距
 * @param {number} params.animationParam.top 动画上边距
 */
export function setInitAnimation({isFeedAnimation, animationParam}) {
    if (!isFeedAnimation) {
        return;
    }
    const {
        width,
        left,
        top
    } = animationParam;
    const {style: bodyStyle} =  document.body;
    // 计算缩放比例
    const scale = width / window.innerWidth;
    const scaleX = (1 - scale);
    bodyStyle.transform = `scale(${scale})`;
    bodyStyle.transformOrigin = `${left / scaleX}px ${top / scaleX}px`;
    bodyStyle.opacity = '0';
    bodyStyle.background = 'transparent';

    const app = document.getElementById('app');
    app.style.overflowY = 'hidden';


    setTimeout(() => {
        setAnimation({
            scale: 1,
            background: 'transparent',
            transition: 'all 200ms ease-in',
            opacity: '1'
        });
        document.body.addEventListener('transitionend', onTransitionEnd);
    });
}
/**
 * 设置页面动画效果
 *
 * @param {number} scale - 缩放比例，默认为1
 * @param {string} background - 背景颜色，默认为透明
 * @param {string} transition - 过渡效果，默认为'all 200ms ease-in'
 * @param {number} opacity - 透明度，默认为1
 */
export function setAnimation({scale = 1, background = 'transparent', transition = 'all 200ms ease-in', opacity = 1}) {
    let {style: bodyStyle} =  document.body;
    bodyStyle.transform = `scale(${scale})`;
    bodyStyle.background = background;
    bodyStyle.transition = transition;
    bodyStyle.opacity = opacity;
}

/**
 * 当过渡效果结束时触发的事件处理函数
 *
 * @param {Event} event - 事件对象
 */
export function onTransitionEnd(event) {
    if (event.target === document.body) {
        let {style: bodyStyle} =  document.body;
        // bodyStyle.height = height;
        bodyStyle.transform = 'none';
        bodyStyle.transition = 'none';
        bodyStyle.background = '#f2f4f5';
        bodyStyle.transformScale = 'none';
        // 清理：移除事件监听器，以防内存泄漏
        document.body.removeEventListener('transitionend', onTransitionEnd);
    }
}


/**
 * 返回动画函数
 *
 * @param {Object} options - 配置参数
 * @param {boolean} options.isFeedAnimation - 是否为Feed动画
 * @param {Object} options.animationParam - 动画参数
 */
export function goBackAnimation({isFeedAnimation, animationParam}) {
    //  在 200ms 时goback 关闭页面
    setTimeout(() => {
        location.href = 'bdapi://finishpage?needUpdate=1';
    }, 200);
    const {
        width
    } = animationParam;
    const scale =  (width / window.innerWidth);
    setAnimation({
        scale,
        background: 'transparent',
        opacity: '1',
        transition: 'all 200ms ease-out'
    });
    document.body.removeEventListener('transitionend', onTransitionEnd);
}